<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-warning"/> {{caption}}
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
      >

      <template #announcment>
          <td>
            <button> <CIcon name="cil-magnifying-glass"/> View Annoucment Detail </button>
          </td>
      </template>
        <template #status="{item}">
          <td>
            <CBadge :color="getBadge(item.status)">{{item.status}}</CBadge>
          </td>
        </template>
         <template #action>
          <td>
            <CButton size="sm" variant="primary" color="info" >Edit Data</CButton>
            <CButton size="sm" variant="primary" class="ml-3" color="warning" >Deactivate</CButton>
          </td>  
           
      </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'Table',
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return ['subject', 'announcment', 'intended-for', 'status', 'action']
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    }
  }
}
</script>
